"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSeasonById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Updates a season by given ID (if it exists).
 *
 * Season is identified by its stringified `ObjectID`.
 *
 * ### Updatable fields
 * - `name`
 * - `description`
 * - `icon`
 *
 * ## Usage
 *
 * ```ts
 * const seasonId: string = "9e9f99daa45c7";
 * const season: Partial<Season> = {
 * 	name: "Updated season name",
 * };
 *
 * const {
 * 	acknowledged,
 * 	matchedCount,
 * 	modifiedCount,
 * 	upsertedCount,
 * 	upsertedId,
 * } = await sdk.updateSeasonById({ seasonId, season });
 * ```
 *
 * @param params.seasonId - ID of the season to be updated.
 * @param params.season   - fields that should be changed in a season, if it exists.
 */
const updateSeasonById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { seasonId, season } = params;
    const url = `${BASE_URL}/seasons/season/${seasonId}`;
    const seasonResponse = yield axios_1.default.put(url, season, { validateStatus: () => true });
    const { status, data } = seasonResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.updateSeasonById = updateSeasonById;
